import { useState, createContext } from "react";

export const UserContext = createContext(null);

const UserContextProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    const _2mseamlessTailoring = localStorage.getItem("_2mseamlessTailoring");
    if (_2mseamlessTailoring !== null) {
      return true;
    } else {
      return false;
    }
  });
  const [userData, setUserData] = useState(() => {
    const _2mseamlessTailoring = localStorage.getItem("_2mseamlessTailoring");
    if (_2mseamlessTailoring !== null) {
      return JSON.parse(_2mseamlessTailoring);
    } else {
      return {};
    }
  });
  const [profileData, setProfileData] = useState(() => {
    const _2mseamlessTailoring_Profile = localStorage.getItem("_2mseamlessTailoring_Profile");
    if (_2mseamlessTailoring_Profile !== null) {
      return JSON.parse(_2mseamlessTailoring_Profile);
    } else {
      return {};
    }
  });

  const value = {
    isLoggedIn,
    setIsLoggedIn,
    userData,
    setUserData,
    profileData,
    setProfileData,
  };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

export default UserContextProvider;
